var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "eu-flex-item eu-basis_12" }, [
    _c("p", { staticClass: "emd-card-grid__line" }, [
      _c(
        "button",
        {
          staticClass: "emd-btn _type_link _color_info",
          on: { click: _vm.viewBoleto },
        },
        [
          _c("span", {
            staticClass: "uil uil-invoice",
            attrs: { transform: "width-16" },
          }),
          _vm._v(
            " " +
              _vm._s(
                _vm.$t("charge.detail.payment-method.boleto.view-boleto")
              ) +
              " "
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }